import type { Attachment } from "@/react/types/Attachment";

export const getAttachmentAspectRatio = (attachment: Attachment): number => {
  const aspectRatio = attachment.metadata?.display_aspect_ratio;
  if (aspectRatio) {
    return aspectRatio[0] / aspectRatio[1];
  }
  const width = attachment.metadata?.width;
  const height = attachment.metadata?.height;
  if (width && height) {
    return width / height;
  }
  return 16 / 9;
};
